/** @module polyfills */

/**
 * Ensure support for new attribute `inert`.
 * @see https://whatpr.org/html/4288/interaction.html#the-inert-attribute
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/inert
 */
export function inert() {
    import(/* webpackMode: "eager" */ 'wicg-inert');
}
